module.exports = __webpack_public_path__ + "img/single-neutral-actions-remove.02fe3458.svg";